export const ServiceHost = 'https://service.coompnk.xyz/api'